import { render, staticRenderFns } from "./BusinessSellingView.vue?vue&type=template&id=12a16a7a&"
import script from "./BusinessSellingView.vue?vue&type=script&lang=ts&"
export * from "./BusinessSellingView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports